<template>
  <div
    class="py-4 px-11 primary3 w-100 d-flex align-center justify-space-between mb-4"
  >
    <div class="d-flex align-center primary--text">
      <v-icon clr="var(--v-primary-base)">$warning</v-icon>
      <span class="ms-1 font-Regular-14">{{
        $t("corporateAccount.mainDashboard.legalAccountSignin")
      }}</span>
    </div>
    <div
      class="d-flex align-center primary--text"
      style="cursor: pointer"
      @click="dontShowMe"
    >
      <span class="me-1 font-Medium-14">{{
        $t("corporateAccount.mainDashboard.dontShowAgain")
      }}</span>
      <v-icon clr="var(--v-primary-base)">$modalClose</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: "LegalAlert",
  data() {
    return {};
  },
  methods: {
    dontShowMe() {
      this.$emit("dontShowMe");
    }
  }
};
</script>
